import permissions from 'constants/permissions'

const COMPANY_KANBAN_TASK_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.COMPANY_KANBAN_TASKS.LIST,
  },
  {
    name: 'Criar',
    tag: permissions.COMPANY_KANBAN_TASKS.CREATE,
  },
  {
    name: 'Atualizar',
    tag: permissions.COMPANY_KANBAN_TASKS.UPDATE,
  },
  {
    name: 'Excluir',
    tag: permissions.COMPANY_KANBAN_TASKS.DESTROY,
  },
  {
    name: 'Finalizar',
    tag: permissions.COMPANY_KANBAN_TASKS.FINALIZE,
  },
]

export default COMPANY_KANBAN_TASK_LIST
